module.exports = __webpack_public_path__ + "img/2.cd662627.png";